import type { HowToPlayPageData } from "@/components/HowToPlayPage";

export function buildFaqJsonLd(data: Pick<HowToPlayPageData, "faqs">) {
  return [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: data.faqs.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: f.answer },
      })),
    },
    // Speakable schema improves discoverability via voice assistants and
    // Google Assistant news/answer surfaces (AEO).
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      speakable: {
        "@type": "SpeakableSpecification",
        cssSelector: ["h1", "h2", "[data-speakable]"],
      },
    },
  ];
}